<template>
  <li @click="onShow()">
    <i></i>
    <span>分享</span>
    <share v-show="showMask" :info="shareData" @hide="hide"/>
  </li>
</template>
<script>
import share from '@/components/share.vue'
export default {
  name: 'share-button',
  components: {
    share
  },
  props: {
    shareData: {
      type: Object
    }
  },
  data() {
    return {
      showMask: false
    }
  },
  methods: {
    onShow() {
      var event = window.event
      if (event) {
        if (!event.srcElement.classList.contains('coverShare')) {
          this.showMask = true
        }
      } else {
        this.showMask = true
      }
    },
    hide() {
      this.showMask = false
    }
  },
  created() {},
  watch: {
    showMask: function(newValue, oldValue) {
      // console.log('showMaskChange:' + newValue + ',' + oldValue)
    }
  }
}
</script>
